var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { useEffect, useState, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { deleteInvoiceData, getDraftOrderData, draftOrderDetails, sendInvoiceData } from "../../../reduxStore/actions/salesRepDataAction";
import store from "../../../reduxStore/store";
import { isLoading, salesOrderSearchText } from "../../../services/behaviorSubjectService";
import { SalesRepDataActionType } from "../../../reduxStore/actions/actionTypes";
import { EDIT_ORDER_FLAG } from "../../Constant";
import { formatIssueDateFromObject, formatDueDateFromObject, getPaymentTermsDescription, getDisplayPaymentTermsData } from "../../SharedFunctions";
import { resolvePaymentTermsForDisplay } from "../../PaymentTerms/DraftOrderPaymentTerms";
import { handleDuplicateOrderFromDialog } from "../SalesOrderDetailsSharedBL";
export function DraftOrderBL(columnVisibility) {
    var _this = this;
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
    var t = useTranslation().t;
    var dispatch = useDispatch();
    var cv = columnVisibility;
    var shopCurrency = store.getState().salesRepData.loggedInRepDetails.shopCurrency;
    var currency = store.getState().salesRepData.loggedInRepDetails.currency;
    var selectFeatures = (_a = store.getState().salesRepData.baseData.select) !== null && _a !== void 0 ? _a : {};
    var DraftOrdersHeaderNames = [
        {
            label: t("draftOrder_OrderNumber"),
            hidden: (cv === null || cv === void 0 ? void 0 : cv.orderNumber) === false,
        },
        {
            label: t("draftOrder_CustName"),
            hidden: (cv === null || cv === void 0 ? void 0 : cv.customerName) === false,
        },
        {
            label: t("salesDetailsHeader_Company"),
            hidden: !(selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.CreateB2BOrder) || (cv === null || cv === void 0 ? void 0 : cv.companyName) === false,
        },
        {
            label: t("salesDetailsHeader_Location"),
            hidden: !(selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.CreateB2BOrder) || (cv === null || cv === void 0 ? void 0 : cv.companyLocation) === false,
        },
        {
            label: t("draftOrder_OrderDate"),
            hidden: (cv === null || cv === void 0 ? void 0 : cv.orderDate) === false,
        },
        {
            label: t("draftOrder_SubTotal") + "(" + shopCurrency + ")",
            inlineCSS: { textAlign: "center" },
            hidden: (cv === null || cv === void 0 ? void 0 : cv.subtotal) === false,
        },
        {
            label: t("draftOrder_Status"),
            inlineCSS: { textAlign: "center" },
            hidden: (cv === null || cv === void 0 ? void 0 : cv.status) === false,
        },
        {
            label: t("yourSales_Action"),
            inlineCSS: { textAlign: "center" },
            hidden: false,
        },
    ];
    var DraftOrderProductHeaderNames = [
        {
            label: t("draftOrder_Product"),
        },
        {
            label: t("draftOrder_ProductName"),
        },
        {
            label: t("draftOrder_Size"),
        },
        {
            label: t("draftOrder_Quantity"),
        },
        {
            label: t("draftOrder_Price"),
        },
        {
            label: t("draftOrder_Status"),
        },
        {
            label: t("draftOrder_SubTotal"),
        },
    ];
    var draftOrderFilter = function (draftOrderData) {
        var _a;
        return ((_a = draftOrderData === null || draftOrderData === void 0 ? void 0 : draftOrderData.filter(function (data) {
            var _a, _b;
            return ((_a = data === null || data === void 0 ? void 0 : data.status) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === "open" || ((_b = data === null || data === void 0 ? void 0 : data.status) === null || _b === void 0 ? void 0 : _b.toLowerCase()) === "voided";
        })) !== null && _a !== void 0 ? _a : []);
    };
    var _m = useState(false), openDraftProductDataDialog = _m[0], setOpenDraftProductDataDialog = _m[1];
    /** Draft list row when the detail dialog is open (B2B / actions in shared dialog). */
    var _o = useState(null), draftDialogListRow = _o[0], setDraftDialogListRow = _o[1];
    var _p = useState((_d = draftOrderFilter((_c = (_b = store === null || store === void 0 ? void 0 : store.getState()) === null || _b === void 0 ? void 0 : _b.salesRepData) === null || _c === void 0 ? void 0 : _c.draftOrderData)) !== null && _d !== void 0 ? _d : []), draftOrderArray = _p[0], setDraftOrderArray = _p[1];
    var _q = useState(!(((_h = draftOrderFilter((_g = (_f = (_e = store === null || store === void 0 ? void 0 : store.getState()) === null || _e === void 0 ? void 0 : _e.salesRepData) === null || _f === void 0 ? void 0 : _f.draftOrderData) !== null && _g !== void 0 ? _g : [])) === null || _h === void 0 ? void 0 : _h.length) > 0)), orderesLoading = _q[0], setOrdersLoading = _q[1];
    var _r = useState(), activeClientObj = _r[0], setActiveClientObj = _r[1];
    var _s = useState(""), activeClientOrderId = _s[0], setActiveClientOrderId = _s[1];
    var _t = useState([]), draftOrderProductDetailsArray = _t[0], setDraftOrderProductDetailsArray = _t[1];
    var _u = useState(0), sendInvoiceIndex = _u[0], setSendInvoiceIndex = _u[1];
    var _v = useState(false), sendInvoiceFlag = _v[0], setSendInvoiceFlag = _v[1];
    var _w = useState(0), deleteInvoiceIndex = _w[0], setDeleteInvoiceIndex = _w[1];
    var _x = useState(false), deleteInvoiceFlag = _x[0], setDeleteInvoiceFlag = _x[1];
    var _y = useState(false), successFlag = _y[0], setSuccessFlag = _y[1];
    var _z = useState(false), deleteConfirmation = _z[0], setDeleteConfirmation = _z[1];
    var _0 = useState({ itemOrderId: 0, index: 0 }), deleteDraftOrder = _0[0], setDeleteDraftOrder = _0[1];
    var _1 = useState((_l = draftOrderFilter((_k = (_j = store === null || store === void 0 ? void 0 : store.getState()) === null || _j === void 0 ? void 0 : _j.salesRepData) === null || _k === void 0 ? void 0 : _k.draftOrderData)) !== null && _l !== void 0 ? _l : []), filtered = _1[0], setFiltered = _1[1];
    var _2 = useState(""), searchDraftOrderText = _2[0], setSearchDraftOrderText = _2[1];
    var _3 = useState(null), menuAnchorEl = _3[0], setMenuAnchorEl = _3[1];
    var _4 = useState(null), selectedOrder = _4[0], setSelectedOrder = _4[1];
    var _5 = useState({ msg: "", open: false, severity: "error" }), alertErrorMsg = _5[0], setAlertErrorMsg = _5[1];
    var displayPaymentTerms = useMemo(function () {
        return resolvePaymentTermsForDisplay(activeClientObj);
    }, [activeClientObj]);
    var displayPaymentTermsData = useMemo(function () { return getDisplayPaymentTermsData(displayPaymentTerms, activeClientObj === null || activeClientObj === void 0 ? void 0 : activeClientObj.paymentTerms); }, [displayPaymentTerms, activeClientObj === null || activeClientObj === void 0 ? void 0 : activeClientObj.paymentTerms]);
    useEffect(function () {
        getDraftOrder();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    useEffect(function () {
        var filterTable = salesOrderSearchText === null || salesOrderSearchText === void 0 ? void 0 : salesOrderSearchText.subscribe(function (data) {
            if ((data === null || data === void 0 ? void 0 : data.orderTab) === "Draft" && (data === null || data === void 0 ? void 0 : data.searchText) !== searchDraftOrderText) {
                setSearchDraftOrderText(data === null || data === void 0 ? void 0 : data.searchText);
                var updatedArray = __spreadArray([], filtered, true);
                var filteredOrders = updatedArray === null || updatedArray === void 0 ? void 0 : updatedArray.filter(function (order) { var _a, _b, _c, _d, _e, _f; return ((_b = (_a = order === null || order === void 0 ? void 0 : order.customername) === null || _a === void 0 ? void 0 : _a.toLowerCase()) === null || _b === void 0 ? void 0 : _b.includes((_c = data === null || data === void 0 ? void 0 : data.searchText) === null || _c === void 0 ? void 0 : _c.toLowerCase())) || ((_e = (_d = order === null || order === void 0 ? void 0 : order.orderName) === null || _d === void 0 ? void 0 : _d.toLowerCase()) === null || _e === void 0 ? void 0 : _e.includes((_f = data === null || data === void 0 ? void 0 : data.searchText) === null || _f === void 0 ? void 0 : _f.toLowerCase())); });
                setDraftOrderArray(filteredOrders);
            }
        });
        return function () { return filterTable.unsubscribe(); };
    }, [draftOrderArray, searchDraftOrderText, setDraftOrderArray]);
    var getDraftOrder = function () { return __awaiter(_this, void 0, void 0, function () {
        var draftOrderResponseData;
        var _a, _b, _c, _d, _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    isLoading.next(true);
                    return [4 /*yield*/, dispatch(getDraftOrderData())];
                case 1:
                    draftOrderResponseData = _g.sent();
                    isLoading.next(false);
                    setOrdersLoading(false);
                    if (draftOrderResponseData && store.getState().salesRepData.draftOrderData) {
                        setDraftOrderArray(draftOrderFilter((_c = (_b = (_a = store.getState()) === null || _a === void 0 ? void 0 : _a.salesRepData) === null || _b === void 0 ? void 0 : _b.draftOrderData) !== null && _c !== void 0 ? _c : []));
                        setFiltered(draftOrderFilter((_f = (_e = (_d = store.getState()) === null || _d === void 0 ? void 0 : _d.salesRepData) === null || _e === void 0 ? void 0 : _e.draftOrderData) !== null && _f !== void 0 ? _f : []));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getDraftOrderDetails = function (item, actionEvent) {
        if (actionEvent === void 0) { actionEvent = ""; }
        return __awaiter(_this, void 0, void 0, function () {
            var params, draftOrderDetailsResponse;
            var _a, _b;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        isLoading.next(true);
                        params = {
                            order_id: item.orderid,
                        };
                        return [4 /*yield*/, dispatch(draftOrderDetails(params, actionEvent))];
                    case 1:
                        draftOrderDetailsResponse = _c.sent();
                        if (actionEvent !== EDIT_ORDER_FLAG) {
                            setDraftDialogListRow(item);
                            setOpenDraftProductDataDialog(true);
                        }
                        setDraftOrderProductDetailsArray((_a = draftOrderDetailsResponse === null || draftOrderDetailsResponse === void 0 ? void 0 : draftOrderDetailsResponse.ProductDetails) !== null && _a !== void 0 ? _a : []);
                        setActiveClientObj((_b = draftOrderDetailsResponse === null || draftOrderDetailsResponse === void 0 ? void 0 : draftOrderDetailsResponse.draftOrder) !== null && _b !== void 0 ? _b : {});
                        setActiveClientOrderId(item.orderid); // Store the original orderid for delete operation
                        isLoading.next(false);
                        return [2 /*return*/];
                }
            });
        });
    };
    var closeDraftProductDataDialog = function () {
        setOpenDraftProductDataDialog(false);
        setDraftDialogListRow(null);
    };
    var sendInvoice = function (item, index) { return __awaiter(_this, void 0, void 0, function () {
        var isB2BOrder, emailToUse, params_1, draftOrderDetailsResponse, error_1, params, sendInvoiceResponse;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    setSendInvoiceIndex(index);
                    setSendInvoiceFlag(true);
                    isB2BOrder = (item === null || item === void 0 ? void 0 : item.B2BCompanyName) && (item === null || item === void 0 ? void 0 : item.B2BLocationName);
                    emailToUse = item.emailid || "";
                    if (!(isB2BOrder && !emailToUse)) return [3 /*break*/, 4];
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    params_1 = {
                        order_id: item.orderid,
                    };
                    return [4 /*yield*/, dispatch(draftOrderDetails(params_1, ""))];
                case 2:
                    draftOrderDetailsResponse = _b.sent();
                    if (draftOrderDetailsResponse === null || draftOrderDetailsResponse === void 0 ? void 0 : draftOrderDetailsResponse.draftOrder) {
                        // Try to get email from draftOrderObj.email or draftOrderObj.customer?.email
                        emailToUse = draftOrderDetailsResponse.draftOrder.email || ((_a = draftOrderDetailsResponse.draftOrder.customer) === null || _a === void 0 ? void 0 : _a.email) || item.emailid || "";
                    }
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _b.sent();
                    console.error("Error fetching draft order details for B2B send invoice:", error_1);
                    return [3 /*break*/, 4];
                case 4:
                    params = {
                        orderid: item.orderid,
                        emailid: emailToUse,
                    };
                    return [4 /*yield*/, dispatch(sendInvoiceData(params))];
                case 5:
                    sendInvoiceResponse = _b.sent();
                    if (sendInvoiceResponse) {
                        setSuccessFlag(true);
                        setTimeout(function () {
                            setSuccessFlag(false);
                        }, 3000);
                    }
                    setSendInvoiceFlag(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var openDeleteInvoiceConfirmation = function (item, index) {
        setDeleteDraftOrder({ itemOrderId: item.orderid, index: index });
        setDeleteConfirmation(true);
    };
    var handleDeleteFromPopup = function () {
        if (activeClientOrderId) {
            var orderIndex = draftOrderArray.findIndex(function (order) { return order.orderid === activeClientOrderId; });
            setDeleteDraftOrder({ itemOrderId: activeClientOrderId, index: orderIndex >= 0 ? orderIndex : 0 });
            setDeleteConfirmation(true);
            setOpenDraftProductDataDialog(false);
            setDraftDialogListRow(null);
        }
    };
    var cancelDeleteConfirmation = function () {
        setDeleteConfirmation(false);
        setDeleteInvoiceFlag(false);
    };
    var deleteInvoice = function () { return __awaiter(_this, void 0, void 0, function () {
        var deleteInvoiceResponse;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    setDeleteInvoiceIndex(deleteDraftOrder.index);
                    setDeleteInvoiceFlag(true);
                    return [4 /*yield*/, dispatch(deleteInvoiceData(deleteDraftOrder.itemOrderId))];
                case 1:
                    deleteInvoiceResponse = _d.sent();
                    if (deleteInvoiceResponse && deleteInvoiceResponse !== null) {
                        setDeleteInvoiceIndex(0);
                        setDraftOrderArray((_c = draftOrderFilter((_b = (_a = store.getState()) === null || _a === void 0 ? void 0 : _a.salesRepData) === null || _b === void 0 ? void 0 : _b.draftOrderData)) !== null && _c !== void 0 ? _c : []);
                        setDeleteConfirmation(false);
                    }
                    setDeleteInvoiceFlag(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var handleEditOrder = function (item) { return __awaiter(_this, void 0, void 0, function () {
        var editDraftOrder, b2bCompany, isB2BOrder, isB2BFeatureEnabled, activeTabsBeforeB2B, b2BTabIndex, update_ActiveTab_InReduxStore, update_ActiveTab_InReduxStore;
        var _a, _b, _c, _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0: return [4 /*yield*/, getDraftOrderDetails(item, EDIT_ORDER_FLAG)];
                case 1:
                    _f.sent();
                    editDraftOrder = (_b = (_a = store.getState().salesRepData) === null || _a === void 0 ? void 0 : _a.editDraftOrder) !== null && _b !== void 0 ? _b : {};
                    if ((editDraftOrder === null || editDraftOrder === void 0 ? void 0 : editDraftOrder.draftOrderObj) && ((_c = Object.keys(editDraftOrder === null || editDraftOrder === void 0 ? void 0 : editDraftOrder.draftOrderObj)) === null || _c === void 0 ? void 0 : _c.length) !== 0 && ((_d = editDraftOrder === null || editDraftOrder === void 0 ? void 0 : editDraftOrder.productDetailsArray) === null || _d === void 0 ? void 0 : _d.length) > 0) {
                        b2bCompany = (_e = editDraftOrder === null || editDraftOrder === void 0 ? void 0 : editDraftOrder.draftOrderObj) === null || _e === void 0 ? void 0 : _e.b2bCompany;
                        isB2BOrder = ((b2bCompany === null || b2bCompany === void 0 ? void 0 : b2bCompany.id) && (b2bCompany === null || b2bCompany === void 0 ? void 0 : b2bCompany.location_id)) || ((item === null || item === void 0 ? void 0 : item.B2BCompanyName) && (item === null || item === void 0 ? void 0 : item.B2BLocationName));
                        if (isB2BOrder) {
                            isB2BFeatureEnabled = selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.CreateB2BOrder;
                            if (isB2BFeatureEnabled) {
                                activeTabsBeforeB2B = 0;
                                // Dashboard (index 0) is always active
                                activeTabsBeforeB2B++;
                                // Create Order tab (index 1) - check if active
                                if ((selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.CreateInvoice) || (selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.CreateCheckout) || (selectFeatures === null || selectFeatures === void 0 ? void 0 : selectFeatures.CreateOrder)) {
                                    activeTabsBeforeB2B++;
                                }
                                b2BTabIndex = activeTabsBeforeB2B;
                                update_ActiveTab_InReduxStore = {
                                    payload: { activeTabIndex: b2BTabIndex, actionEvent: EDIT_ORDER_FLAG },
                                    type: SalesRepDataActionType.ACTIVE_TAB,
                                };
                                dispatch(update_ActiveTab_InReduxStore);
                            }
                        }
                        else {
                            update_ActiveTab_InReduxStore = {
                                payload: { activeTabIndex: 1, actionEvent: EDIT_ORDER_FLAG },
                                type: SalesRepDataActionType.ACTIVE_TAB,
                            };
                            dispatch(update_ActiveTab_InReduxStore);
                        }
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var handleDuplicateDraftOrder = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setOpenDraftProductDataDialog(false);
                    setDraftDialogListRow(null);
                    return [4 /*yield*/, handleDuplicateOrderFromDialog(activeClientObj, (activeClientObj === null || activeClientObj === void 0 ? void 0 : activeClientObj.id) || (activeClientObj === null || activeClientObj === void 0 ? void 0 : activeClientObj.orderid), true, dispatch, setAlertErrorMsg, t)];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    // Menu handlers for Action column
    var handleMenuClick = function (event, order) {
        event.preventDefault();
        event.stopPropagation();
        if (menuAnchorEl && (selectedOrder === null || selectedOrder === void 0 ? void 0 : selectedOrder.orderid) === order.orderid) {
            setMenuAnchorEl(null);
            setSelectedOrder(null);
        }
        else {
            setMenuAnchorEl(event.currentTarget);
            setSelectedOrder(order);
        }
    };
    var handleMenuClose = function () {
        setMenuAnchorEl(null);
        setSelectedOrder(null);
    };
    var handleEditDraftFromTable = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    handleMenuClose();
                    if (!selectedOrder) return [3 /*break*/, 2];
                    return [4 /*yield*/, handleEditOrder(selectedOrder)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var handleDuplicateDraftOrderFromTable = function () { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    handleMenuClose();
                    if (!selectedOrder) return [3 /*break*/, 2];
                    return [4 /*yield*/, handleDuplicateOrderFromDialog(selectedOrder, selectedOrder.orderid, true, dispatch, setAlertErrorMsg, t)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var handleSendInvoiceFromTable = function () { return __awaiter(_this, void 0, void 0, function () {
        var index;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    handleMenuClose();
                    if (!selectedOrder) return [3 /*break*/, 2];
                    index = draftOrderArray.findIndex(function (order) { return order.orderid === selectedOrder.orderid; });
                    if (!(index >= 0)) return [3 /*break*/, 2];
                    return [4 /*yield*/, sendInvoice(selectedOrder, index)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var handleDeleteDraftFromTable = function () {
        if (selectedOrder) {
            var index = draftOrderArray.findIndex(function (order) { return order.orderid === selectedOrder.orderid; });
            if (index >= 0) {
                openDeleteInvoiceConfirmation(selectedOrder, index);
            }
        }
        handleMenuClose();
    };
    var handleEditOrderFromDialog = function () { return __awaiter(_this, void 0, void 0, function () {
        var item;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(activeClientObj && activeClientOrderId)) return [3 /*break*/, 2];
                    item = draftOrderArray.find(function (order) { return order.orderid === activeClientOrderId; });
                    if (!item) return [3 /*break*/, 2];
                    return [4 /*yield*/, handleEditOrder(item)];
                case 1:
                    _a.sent();
                    closeDraftProductDataDialog();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var handleSendInvoiceFromDialog = function () { return __awaiter(_this, void 0, void 0, function () {
        var item, index;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!(activeClientObj && activeClientOrderId)) return [3 /*break*/, 2];
                    item = draftOrderArray.find(function (order) { return order.orderid === activeClientOrderId; });
                    if (!item) return [3 /*break*/, 2];
                    index = draftOrderArray.findIndex(function (order) { return order.orderid === activeClientOrderId; });
                    return [4 /*yield*/, sendInvoice(item, index >= 0 ? index : 0)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var handleAlertMsgClose = function (event, reason) {
        if (reason === "clickaway") {
            return;
        }
        setAlertErrorMsg({ msg: "", open: false });
    };
    return {
        DraftOrdersHeaderNames: DraftOrdersHeaderNames,
        DraftOrderProductHeaderNames: DraftOrderProductHeaderNames,
        openDraftProductDataDialog: openDraftProductDataDialog,
        orderesLoading: orderesLoading,
        setOpenDraftProductDataDialog: setOpenDraftProductDataDialog,
        closeDraftProductDataDialog: closeDraftProductDataDialog,
        draftDialogListRow: draftDialogListRow,
        draftOrderArray: draftOrderArray,
        getDraftOrderDetails: getDraftOrderDetails,
        activeClientObj: activeClientObj,
        draftOrderProductDetailsArray: draftOrderProductDetailsArray,
        t: t,
        sendInvoice: sendInvoice,
        openDeleteInvoiceConfirmation: openDeleteInvoiceConfirmation,
        handleDeleteFromPopup: handleDeleteFromPopup,
        sendInvoiceIndex: sendInvoiceIndex,
        sendInvoiceFlag: sendInvoiceFlag,
        deleteInvoiceFlag: deleteInvoiceFlag,
        setDeleteInvoiceFlag: setDeleteInvoiceFlag,
        deleteInvoiceIndex: deleteInvoiceIndex,
        successFlag: successFlag,
        deleteConfirmation: deleteConfirmation,
        setDeleteConfirmation: setDeleteConfirmation,
        cancelDeleteConfirmation: cancelDeleteConfirmation,
        deleteInvoice: deleteInvoice,
        shopCurrency: shopCurrency,
        getDraftOrder: getDraftOrder,
        handleEditOrder: handleEditOrder,
        selectFeatures: selectFeatures,
        currency: currency,
        handleDuplicateDraftOrder: handleDuplicateDraftOrder,
        menuAnchorEl: menuAnchorEl,
        selectedOrder: selectedOrder,
        handleMenuClick: handleMenuClick,
        handleMenuClose: handleMenuClose,
        handleEditDraftFromTable: handleEditDraftFromTable,
        handleDuplicateDraftOrderFromTable: handleDuplicateDraftOrderFromTable,
        handleSendInvoiceFromTable: handleSendInvoiceFromTable,
        handleDeleteDraftFromTable: handleDeleteDraftFromTable,
        handleEditOrderFromDialog: handleEditOrderFromDialog,
        handleSendInvoiceFromDialog: handleSendInvoiceFromDialog,
        alertErrorMsg: alertErrorMsg,
        handleAlertMsgClose: handleAlertMsgClose,
        displayPaymentTerms: displayPaymentTerms,
        displayPaymentTermsData: displayPaymentTermsData,
        getPaymentTermsDescription: getPaymentTermsDescription,
        getIssueDate: function () { return formatIssueDateFromObject(displayPaymentTermsData); },
        getDueDate: function () { return formatDueDateFromObject(displayPaymentTermsData); },
    };
}
